//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/reports/views/main/lan/es';
import overview from 'Modules/reports/views/overview/lan/es';

//Merge Components
import reportExportHistory from 'Modules/reports/.components/reportExportHistory/lan/es';

locales = { ...locales, ...main, ...overview, ...reportExportHistory };


export default locales;